import { render, staticRenderFns } from "./CartaoDeDatas.vue?vue&type=template&id=05ff76ea&scoped=true"
import script from "./CartaoDeDatas.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDeDatas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDeDatas.vue?vue&type=style&index=0&id=05ff76ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ff76ea",
  null
  
)

export default component.exports